import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
export function Testimonials() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const testimonials = [{
    id: 1,
    name: 'Henry R.',
    initial: 'H',
    location: '📍 Pereira, Colombia',
    treatment: 'Perfeccionamiento en Resina',
    quote: 'Me es grato expresar mi satisfacción total con la atención prestada por todo el equipo. Excelente personal profesional, muy cuidadosos en su trabajo, atentos a cualquier necesidad del paciente, con mucha paciencia.',
    bgImage: 'https://cdn.magicpatterns.com/uploads/4Q17ax49VXTuYDC2c1zvvb/quiero_que_a_esat_foto_le_quit_Nano_Banana_2_23957.png'
  }, {
    id: 2,
    name: 'Consuelo A.',
    initial: 'C',
    location: '📍 Pereira, Colombia',
    treatment: 'Diseño de Sonrisa en Cerámica',
    quote: 'Definitivamente quedaron hermosos. Gracias Dr. Nicolás, Jhonatan y todo el equipo de Odontología Estética Pereira. Un trabajo increíble que superó todas mis expectativas. Mis más sinceros agradecimientos.'
  }, {
    id: 3,
    name: 'Sandra T.',
    initial: 'S',
    location: '📍 Pereira, Colombia',
    treatment: 'Diseño de Sonrisa en Resina',
    quote: '¡Que trabajo tan estéticamente impecable! Sin duda alguna los mejores en Pereira. El resultado del diseño de sonrisa superó completamente lo que esperaba. Los recomiendo al 100%.'
  }];
  return <section className="py-24 bg-secondary border-t border-border" data-id="element-348">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
        <div className="text-center mb-16" data-id="element-350">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-351">
            Lo que dicen nuestros pacientes
          </h2>
          <p className="text-gold text-lg max-w-2xl mx-auto" data-id="element-352">
            Opiniones 100% reales extraídas de Instagram
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-353">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-card rounded-xl p-8 border-t-4 border-gold relative overflow-hidden flex flex-col h-full" data-id="element-354">
              {/* Optional Background Image Hint */}
              {testimonial.bgImage && <div className="absolute inset-0 opacity-5 pointer-events-none z-0" data-id="element-355">
                  <img src={testimonial.bgImage} alt="" className="w-full h-full object-cover" data-id="element-356" />
                </div>}

              <div className="relative z-10 flex flex-col h-full" data-id="element-357">
                <div className="flex gap-1 mb-6" data-id="element-358">
                  {[...Array(5)].map((_, i) => <Star key={i} size={18} className="text-gold fill-gold" data-id="element-359" />)}
                </div>

                <div className="absolute -top-2 -left-2 text-gold/20 font-serif text-8xl leading-none select-none" data-id="element-360">
                  "
                </div>

                <p className="text-white/90 italic text-sm leading-relaxed mb-8 relative z-10 flex-grow" data-id="element-361">
                  "{testimonial.quote}"
                </p>

                <div className="w-full h-px bg-gold/30 mb-6" data-id="element-362"></div>

                <div className="flex items-center gap-4 mb-4" data-id="element-363">
                  <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center text-primary font-bold text-xl flex-shrink-0" data-id="element-364">
                    {testimonial.initial}
                  </div>
                  <div data-id="element-365">
                    <h4 className="text-white font-bold" data-id="element-366">{testimonial.name}</h4>
                    <p className="text-gray text-xs" data-id="element-367">{testimonial.location}</p>
                  </div>
                </div>

                <div className="inline-flex items-center gap-1.5 bg-primary border border-border rounded-full px-3 py-1.5 w-fit" data-id="element-368">
                  <CheckCircle2 size={14} className="text-gold" data-id="element-369" />
                  <span className="text-gold text-xs font-medium" data-id="element-370">
                    {testimonial.treatment}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Social Proof Bar */}
        <div className="bg-primary border border-border rounded-xl py-6 px-4 flex flex-wrap justify-center gap-x-12 gap-y-4 text-center" data-id="element-371">
          <div className="flex flex-col" data-id="element-372">
            <span className="text-white font-bold text-lg" data-id="element-373">460 ❤️</span>
            <span className="text-gray text-xs uppercase tracking-wider" data-id="element-374">
              Me gusta promedio
            </span>
          </div>
          <div className="hidden md:block w-px h-10 bg-border" data-id="element-375"></div>
          <div className="flex flex-col" data-id="element-376">
            <span className="text-white font-bold text-lg" data-id="element-377">9.986</span>
            <span className="text-gray text-xs uppercase tracking-wider" data-id="element-378">
              Seguidores
            </span>
          </div>
          <div className="hidden md:block w-px h-10 bg-border" data-id="element-379"></div>
          <div className="flex flex-col" data-id="element-380">
            <span className="text-white font-bold text-lg flex items-center justify-center gap-1" data-id="element-381">
              <CheckCircle2 size={18} className="text-blue-400" data-id="element-382" /> Cuenta
              Verificada
            </span>
            <span className="text-gray text-xs uppercase tracking-wider" data-id="element-383">
              Instagram
            </span>
          </div>
          <div className="hidden md:block w-px h-10 bg-border" data-id="element-384"></div>
          <div className="flex flex-col" data-id="element-385">
            <span className="text-white font-bold text-lg" data-id="element-386">571</span>
            <span className="text-gray text-xs uppercase tracking-wider" data-id="element-387">
              Casos Publicados
            </span>
          </div>
        </div>
      </div>
    </section>;
}